export default "__VITE_ASSET__rIhadoxt__"